<span>{{ message }}</span>
    <a style="cursor: pointer;" (click)="performAction(origin)" #origin>{{ linkMessage }}</a>
